import React, { FC } from 'react';
import { Theme } from '@aptuno/aptuno-ui';
import NavbarAptuno from '../Navbar/Navbar';
import { MainWrapper } from './Layout.styled';
import Footer from '../Footer/Footer';
import { CompleteEstateApplicationSticky } from '@contexts/Estate';
import { RenderOnlyInCountries } from '@shared/utils';
import { constants } from '@contexts/Estate/Shared/commons';
import { AptunoMuiThemeProvider } from '../../../styles/theme';

interface LayoutProps {
  // todo: define correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pageProps?: any;
  withoutFooter?: boolean;
}

const Layout: FC<LayoutProps> = ({
  children,
  pageProps,
  withoutFooter = false,
}) => {
  return (
    <Theme colorModes="light">
      <AptunoMuiThemeProvider>
        <div {...pageProps}>
          <NavbarAptuno />
          <MainWrapper>{children}</MainWrapper>
          {!withoutFooter && (
            <>
              <Footer />
              <RenderOnlyInCountries
                countries={constants.ESTATE_APPLICATION_ACTIONS_COUNTRIES}
              >
                <CompleteEstateApplicationSticky />
              </RenderOnlyInCountries>
            </>
          )}
        </div>
      </AptunoMuiThemeProvider>
    </Theme>
  );
};

export default Layout;
